import { render } from "./g-loader.vue?vue&type=template&id=f1179bf0&ts=true"
import script from "./g-loader.vue?vue&type=script&lang=tsx"
export * from "./g-loader.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__